const COLORS_CDR = {
    /* Couleur principale de la police */
    gris_text: '#BFBFBF',
    gris_text_cl: '#D9D9D9',
    /* Couleurs utilisées dans les graphiques */
    g_bleu_f: '#2574A9',
    g_bleu_cl: '#33999F',
    g_rouge: '#EB4C37',
    g_vert: '#46BE81',
    g_jaune: '#FFC000',
    g_gris_f: '#BFBFBF',
    g_gris_cl: '#D9D9D9',
    g_mauve: '#CF557C',
    g_orange: '#E27B2E',
    g_vert_pomme: '#88B14B',
    g_beige: '#D1AF94',
    g_bleu_nuit: '#546090',
    g_gris: '#CX3D454C', // convertir
    g_old_1: '#CX009999', // convertir
    g_old_2: '#CXFF3300', // convertir
    g_old_3: '#CX99FF00', // convertir
    /*GPR ajout de couleurs suite à une anomalie LOOMA 22/05/2019*/
    g_looma_1: '#CXA10048', // convertir
    g_looma_2: '#CXFE80B9', // convertir
    g_looma_3: '#CXFF9900', // convertir
    g_looma_4: '#CX007D47', // convertir
    g_looma_5: '#CX6BB200', // convertir
    g_looma_6: '#CXB26B00', // convertir
    g_looma_7: '#CXFF9900', // convertir
};

export const COLORS_GRAPHS_DEFINITION = {
    /*********         Numerotation des couleurs selon leur ordre de présentation dans les slides AGEO            *******************/
    color_1: { color: COLORS_CDR.g_bleu_f, name: 'g_bleu_f' },
    color_2: { color: COLORS_CDR.g_rouge, name: 'g_rouge' },
    color_3: { color: COLORS_CDR.g_gris_f, name: 'g_gris_f' },
    color_4: { color: COLORS_CDR.g_jaune, name: 'g_jaune' },
    color_5: { color: COLORS_CDR.g_bleu_cl, name: 'g_bleu_cl' },
    color_6: { color: COLORS_CDR.g_vert, name: 'g_vert' },
    color_7: { color: COLORS_CDR.g_bleu_nuit, name: 'g_bleu_nuit' },
    color_8: { color: COLORS_CDR.g_mauve, name: 'g_mauve' },
    color_9: { color: COLORS_CDR.g_beige, name: 'g_beige' },
    color_10: { color: COLORS_CDR.g_gris_cl, name: 'g_gris_cl' },
    color_11: { color: COLORS_CDR.g_old_1, name: 'g_old_1' },
    color_12: { color: COLORS_CDR.g_old_2, name: 'g_old_2' },
    color_13: { color: COLORS_CDR.g_old_3, name: 'g_old_3' },
    /*GPR ajout de couleurs suite à une anomalie LOOMA 22/05/2019*/
    color_14: { color: COLORS_CDR.g_looma_1, name: 'g_looma_1' },
    color_15: { color: COLORS_CDR.g_looma_2, name: 'g_looma_2' },
    color_16: { color: COLORS_CDR.g_looma_3, name: 'g_looma_3' },
    color_17: { color: COLORS_CDR.g_looma_4, name: 'g_looma_4' },
    color_18: { color: COLORS_CDR.g_looma_5, name: 'g_looma_5' },
    color_19: { color: COLORS_CDR.g_looma_6, name: 'g_looma_6' },
    color_20: { color: COLORS_CDR.g_looma_7, name: 'g_looma_7' },
};

export const COLORS_GRAPHS = () => {
    const colors = {};
    for (const [key, value] of Object.entries(COLORS_GRAPHS_DEFINITION)) {
        colors[key] = value.color;
    }
    return colors;
};

export const COLORS_TABLEAU = {
    t_bleu_f: COLORS_CDR.g_bleu_f,
    t_bleu_cl: COLORS_CDR.g_bleu_cl,
    t_gris_f: COLORS_CDR.g_gris_f,
    t_gris_cl: COLORS_CDR.g_gris_cl,
    t_gris: COLORS_CDR.g_gris_cl,
    t_rouge: COLORS_CDR.g_rouge,
    t_couleur1: '#CXC0C0C0', // convertir
    t_couleur2: '#VLIGB', // convertir
};

export const ORDRE_AFFICHAGE_FAMILLE_ET_COULEURS = {
    Hospitalisation: 'color_1',
    Dentaire: 'color_4',
    Optique: 'color_5',
    'Soins courants': 'color_2',
    Pharmacie: 'color_9',
    'Médecine douce': 'color_8',
    Divers: 'color_3',
};

// for Toolbox
export const colorsGraphsArr = () => {
    const colors = {};
    let index = 0;
    for (const [key] of Object.entries(COLORS_GRAPHS)) {
        index++;
        colors[index] = { color: COLORS_GRAPHS[key] };
    }
    console.log(colors);

    return colors;
};

/**
 * Get ordered list of colors for data based on lable
 * if custom ordre is not specify, return default ordered list
 * @param data - [{value: 10, label: 'Optique'}]
 * @param order - {Optique: 'color_5'}
 * @returns colors:[] - [color_5: '#33999F']
 */
export const colorsOrdered = (data, order) => {
    // Set colors
    let colors = [];
    const colorKeysUsed = [];
    let missingColor = order ? 0 : data.length;

    // Get corresponding color or set missing color at position
    if (order) {
        for (const value of Object.values(data)) {
            const colorKey = order?.[value['label']] ? order?.[value['label']] : null;
            if (colorKey) {
                colorKeysUsed.push(colorKey);
                colors[colorKey] = COLORS_GRAPHS_DEFINITION[colorKey].color;
            } else {
                missingColor++;
            }
        }
    }

    if (missingColor) {
        // Get available colors
        const availableColors: [] = [];
        for (const [key, value] of Object.entries(COLORS_GRAPHS_DEFINITION)) {
            if (!colorKeysUsed.includes(key)) {
                availableColors[key] = value.color;
            }
        }
        // Add missing color(s)
        for (let index = 0; index < missingColor; index++) {
            colors[Object.keys(availableColors)[index]] = Object.values(availableColors)[index];
        }
    }

    return colors;
};
